<template>
  <b-card>
    <div v-if="!loading">
      <b-row>
        <b-col cols="12" md="12">
          <div>{{ $t("operation.roles-perms") }}</div>
          <br />
        </b-col>
        <b-col cols="12">
          <b-form-group
            label=""
            v-slot="{ ariaDescribedby }"
            class="modify_checkbox"
          >
            <b-form-checkbox-group v-if="showPermessions">
              <b-form-checkbox
                v-for="option in permessionNames"
                v-model="permissionForm.permissionIds"
                :key="option.value"
                :value="option.value"
                :aria-describedby="ariaDescribedby"
                name="flavour-3a"
              >
                {{ option.text }}
              </b-form-checkbox>
            </b-form-checkbox-group>
          </b-form-group>
        </b-col>
      </b-row>
      <b-row>
        <b-col cols="12" md="12">
          <br />
        </b-col>
        <b-col
          cols="12"
          md="12"
          class="d-flex align-items-center justify-content-start mb-1 mb-md-0"
        >
          <b-button
            variant="primary"
            @click="assignPermissionsToRole()"
            :disabled="submitting"
            block
          >
            <b-spinner small v-if="submitting" class="mr-1"></b-spinner>
            <span v-else>{{ $t("common.submit") }}</span>
          </b-button>
        </b-col>
      </b-row>
    </div>
    <template v-if="loading">
      <div>
        <div class="d-flex justify-content-center mb-1">
          <b-spinner label="Loading..." />
        </div>
      </div>
    </template>
  </b-card>
</template>
<script>
import {
  BCard,
  BRow,
  BCol,
  BFormInput,
  BButton,
  BTable,
  BMedia,
  BAvatar,
  BLink,
  BBadge,
  BDropdown,
  BDropdownItem,
  BPagination,
  BTooltip,
  BFormGroup,
  BSpinner,
  VBModal,
  BFormCheckboxGroup,
  BFormCheckbox,
} from "bootstrap-vue";
import vSelect from "vue-select";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import router from "@/router";
export default {
  components: {
    BCard,
    BRow,
    BCol,
    BFormInput,
    BButton,
    BTable,
    BMedia,
    BAvatar,
    BLink,
    BBadge,
    BDropdown,
    BDropdownItem,
    BPagination,
    BTooltip,
    vSelect,
    BSpinner,
    BFormGroup,
    BFormCheckboxGroup,
    BFormCheckbox,
  },
  data() {
    return {
      submitting: false,
      loading: true,
      page: 1,
      take: 10,
      totalInvoices: 0,
      currentPage: 1,
      takeOptions: [10, 25, 50, 100],
      searchQuery: "",
      totalRows: "",
      sortBy: "id",
      isSortDirDesc: true,
      statusFilter: null,
      addForm: {
        name: "",
      },
      params: {
        form: {},
        path: "",
      },
      permissionForm: {
        permissionIds: [],
      },
      showPermessions: false,
      permessionList: [],
      permessionNames: [],
      removedPermessionIdList: {
        permissionIds: [],
      },
      permessionIdList: [],
    };
  },
  mounted() {
    // this.checkAuth().then(() => {
    this.getPermissions();
    // });
  },
  methods: {
    async index() {
      this.loading = true;
      await this.getList(
        `/role/${router.currentRoute.params.id}?include=permissions`
      );
      this.permessionList = this.all_data.permissions;
      this.all_data.permissions.forEach((item) => {
        this.permissionForm.permissionIds.push(item.id);
        this.permessionIdList.push(item.id);
      });
      this.loading = false;
    },
    async getPermissions() {
      this.loading = true;
      await this.getList(`/permission?take=1000&sort=created_at`);
      this.all_data.data.forEach((item) => {
        this.permessionNames.push({
          value: item.id,
          text: item.name,
        });
      });

      this.showPermessions = true;

      this.index();
      this.loading = false;
    },

    assignPermissionsToRole() {
      this.submitting = true;
      (this.params.form = this.permissionForm),
        (this.params.path = `/give-permissions-to/role/${this.$route.params.id}`),
        this.$store
          .dispatch("create", this.params)
          .then(() => {
            this.submitting = false;
            this.$router.push({
              name: "operations-roles",
            });
            this.$toast({
              component: ToastificationContent,
              position: "top-right",
              props: {
                title: "Permissions Assigned to Role was Updated",
                icon: "InfoIcon",
                variant: "success",
              },
            });
          })
          .catch((error) => {
            this.submitting = false;
            if (error.response.status === 400) {
              for (let item in error.response.data) {
                this.$toast({
                  component: ToastificationContent,
                  position: "top-right",
                  props: {
                    title: "validation error",
                    variant: "danger",
                    text: error.response.data[item][0],
                  },
                });
              }
            }
          });
    },
  },
};
</script>

<style scoped>
.modify_checkbox {
  display: flex;
  flex-flow: row wrap;
  justify-content: flex-start;
  align-items: center;
  row-gap: 30px;
  column-gap: 5px;
}

.custom-checkbox {
  width: 18rem;
  height: 3rem;
}
</style>

<style lang="scss">
@import "@core/scss/vue/libs/vue-select.scss";
</style>
